'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  positionX: _propTypes2.default.string,
  positionY: _propTypes2.default.string,
  visible: _propTypes2.default.bool,
  theme: _propTypes2.default.object
};
var defaultProps = {
  positionX: 'right',
  positionY: 'bottom',
  visible: true
};
/** Prop Receivers */

var baseProps = function baseProps(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.tooltip,
      backgroundColor = _theme$reactackle$com.backgroundColor,
      borderRadius = _theme$reactackle$com.borderRadius,
      paddingY = _theme$reactackle$com.paddingY,
      paddingX = _theme$reactackle$com.paddingX,
      fontSize = _theme$reactackle$com.fontSize,
      fontColor = _theme$reactackle$com.fontColor,
      lineHeight = _theme$reactackle$com.lineHeight,
      minWidth = _theme$reactackle$com.minWidth,
      maxWidth = _theme$reactackle$com.maxWidth;
  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
  return (0, _styledComponents.css)(['background-color:', ';border-radius:', ';padding:', ' ', ';font-size:', ';color:', ';line-height:', ';min-width:', ';max-width:', ';&,& *,*::after,*::before{font-family:', ';box-sizing:border-box;}'], backgroundColor, (0, _reactackleCore.getValueString)(borderRadius), (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX), (0, _reactackleCore.getValueString)(fontSize), fontColor, lineHeight, (0, _reactackleCore.getValueString)(minWidth), (0, _reactackleCore.getValueString)(maxWidth), fontFamily);
};

var visibility = function visibility(_ref2) {
  var visible = _ref2.visible;
  return 'opacity: ' + (visible ? '1' : '0') + ';';
};

var position = function position(_ref3) {
  var positionY = _ref3.positionY,
      positionX = _ref3.positionX,
      themeFromProvider = _ref3.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var tooltipRefererSpacing = theme.reactackle.components.tooltip.tooltipRefererSpacing;
  var spacing = (0, _reactackleCore.getValueString)(tooltipRefererSpacing);
  var alignX = positionX === 'left' ? 'right: ' + spacing + ';' : '\n        left: ' + spacing + ';\n        transform: translateX(-100%);\n      ';
  var alignY = positionY === 'top' ? '\n        top: -' + spacing + ';\n        transform: translateY(-100%);\n      ' : '\n        bottom: -' + spacing + ';\n        transform: translateY(100%);\n      ';
  return (0, _styledComponents.css)(['', ';', ';'], alignX, alignY);
};
/** Styles */


var TooltipStyled = exports.TooltipStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TooltipStyled'
})(['position:absolute;text-align:left;pointer-events:none;opacity:0;width:100%;user-select:none;', ';', ';', ';', ';'], (0, _reactackleCore.transition)('top, bottom, left, right, opacity'), baseProps, visibility, position);

TooltipStyled.propTypes = propTypes;
TooltipStyled.defaultProps = defaultProps;
TooltipStyled.displayName = 'TooltipStyled';